module.exports = __webpack_public_path__ + "img/yixiangsui-propa.c8bbcf4f.png";